import {
  filtersData,
  IFiltersData,
} from '../../shopListingBottomSheet/utils/index';
import {useShopListingFilters} from '../../../../hooks/filters/useShopListingFilter';

const FiltersShopList = () => {
  const {resetFilterShopListing, shopListingFilter, setShopListingFilter} =
    useShopListingFilters();
  return (
    <div className="flex gap-2 items-center">
      <div className="flex gap-2 items-center">
        {shopListingFilter.input_guid?.map(item => (
          <div
            className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap"
            key={item.guid}
          >
            {item.title}
            <i
              className="mr-3 text-lg icon-nameClose-remove"
              onClick={() =>
                setShopListingFilter(
                  'input_guid',
                  shopListingFilter?.input_guid.filter(
                    g => g.guid !== item.guid,
                  ),
                )
              }
            />
          </div>
        ))}
      </div>
      {shopListingFilter.order_by && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <i
            className="mr-3 text-lg icon-nameClose-remove"
            onClick={() => resetFilterShopListing('order_by')}
          />
          <span>
            {
              filtersData.find(
                (item: IFiltersData) =>
                  item.value === shopListingFilter.order_by,
              )?.title
            }
          </span>
        </div>
      )}
      {shopListingFilter.in_person_possibility === true && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span>فروشگاه‌های دارای مراجعه حضوری</span>
          <i
            className="mr-3 text-lg icon-nameClose-remove"
            onClick={() => resetFilterShopListing('in_person_possibility')}
          />
        </div>
      )}
      {shopListingFilter.has_delivery === true && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span>فروشگاه‌های دارای امکان ارسال مرسوله</span>
          <i
            className="mr-3 text-lg icon-nameClose-remove"
            onClick={() => resetFilterShopListing('has_delivery')}
          />
        </div>
      )}
      {shopListingFilter.has_discount === true && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span>فروشگاه‌های دارای تخفیف</span>
          <i
            className="mr-3 text-lg icon-nameClose-remove"
            onClick={() => resetFilterShopListing('has_discount')}
          />
        </div>
      )}
      {shopListingFilter.has_guarantee === true && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <span>فروشگاه‌های دارای ضمانت کیفیت محصول/ خدمت</span>
          <i
            className="mr-3 text-lg icon-nameClose-remove"
            onClick={() => resetFilterShopListing('has_guarantee')}
          />
        </div>
      )}
    </div>
  );
};

export default FiltersShopList;
